import { Typography, Box } from "@mui/material";
import { Button, Modal } from "@covertree/ui";

interface AdditionalInterestRemovalModalProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  interestName: string;
}

export function AdditionalInterestRemovalModal({
  open,
  onConfirm,
  onCancel,
  interestName,
}: AdditionalInterestRemovalModalProps) {
  return (
    <Modal open={open} onClose={onCancel} maxWidth="md" hideCloseButtonAndTitle>
      <Typography variant="h3" mb={2}>
        Are you sure?
      </Typography>
      <Typography color="text.disabled">
        Do you want to remove this additional interest
        {` ${interestName}?`}
      </Typography>
      <Box mt={4} columnGap={3} display="flex">
        <Button onClick={onConfirm} color="error">
          Yes, remove
        </Button>
        <Button onClick={onCancel} variant="outlined">
          No, cancel
        </Button>
      </Box>
    </Modal>
  );
}
